import { jsPDF } from 'jspdf';
import * as Roboto from './Roboto-Regular-normal.js';
import * as RobotoBold from './Roboto-Bold-normal.js';
import 'svg2pdf.js';
import { DateTime } from "luxon";
import {
  CHART_DATE_FORMAT,
  CHART_DATE_FORMAT_MONTH,
  CHART_DATE_FORMAT_DATE_SHORT,
  CHART_DATE_FORMAT_YEAR_SHORT
} from "./constants";

import logoSvgRaw from './style/icons/fathom-one.svg?raw';

const body = document.querySelector("body");


let data;
let resize;
let updateDate;
let startDate, endDate;
let showLoader, hideLoader, updateLoaderMessage;

const titleFillColor = 'rgb(40, 40, 40)';

export function initPdf(
  _data,
  _resize,
  _updateDate,
  _startDate,
  _endDate,
  _showLoader,
  _hideLoader,
  _updateLoaderMessage
) {
  data = _data;
  resize = _resize;
  updateDate = _updateDate;
  startDate = _startDate;
  endDate = _endDate;
  showLoader = _showLoader;
  hideLoader = _hideLoader;
  updateLoaderMessage = _updateLoaderMessage;
}



export function openPdf() {

  showLoader();
  updateLoaderMessage("Building PDF");


  const doc = new jsPDF({
    unit: "px",
    orientation: "landscape",
    hotfixes: ["px-scaling"]
  });


  let width = doc.internal.pageSize.getWidth();
  let height = doc.internal.pageSize.getHeight();
  let bottomMargin = 0;

  // console.log('width', width, 'height', height);

  body.classList.toggle("pdf-export", true);
  // console.log(width, height);
  body.style.width = `${ width * 2 }px`;
  body.style.height = `${ (height * 2) - bottomMargin }px`; // keep it on the page

  resize(data);



  // let html = document.querySelector("#content");




  // return;


  updateFlagImgSrcs();
  drawPdfTitle("Prevalence of SARS-CoV-2 mutations from ");
  drawPdfSourcesFooter();

  // Pick up any images that don't have a 'src', and instead use css 'content', and swap their src out
  body.querySelectorAll("img").forEach(img => {
    let cs = getComputedStyle(img);
    if (cs.content && cs.content !== "normal") {
      let src = cs.content.replace(/url\("/gi, "").replace(/"\)/gi, "");
      console.log(src);
      img.src = src;
    }
  });



  // Pick up boundingClientRects here, before we start mucking with css and the dom,
  // so that positioning on the pdf later is accurate
  let cards = document.querySelectorAll(".card--chart");

  //let svgs = document.querySelectorAll(".card--chart svg");
  let svgs = [];
  let svgRects = [];
  cards.forEach(card => {

    let svg = card.querySelector("svg");

    if (svg) {

      let bb = svg.getBoundingClientRect();

      // console.log(bb);
      card.style.width = `${bb.width  }px`;
      card.style.height = `${bb.height  }px`;

      svgs.push(svg);
      svgRects.push(bb);

    }
  });

  const styles = [];

  let stylesheet;
  for (let x = 0; x < document.styleSheets.length; x++) {
    if (document.styleSheets[x].href.match(/assets\/index|main.less/gi)) {
      stylesheet = document.styleSheets[x];
    }
  }

  let ruleList = stylesheet.cssRules;
  for (let i = 0; i < ruleList.length; i++) {
    //console.log(i, ruleList[i]);

    if (ruleList[i].selectorText && ruleList[i].selectorText.match(/chartLayer|chartLine|chartArea/gi)) {
      styles.push(ruleList[i].cssText);
    }
  }

  svgs.forEach((svg, i) => {

    if (svg) {
      let renderedRect = svgRects[i];

      svg.setAttribute("viewBox", `0, 0, ${   renderedRect.width  }, ${   (renderedRect.height)}`);

      let style = document.createElement("style");
      style.innerHTML = styles.join(" ");
      svg.appendChild(style);

    }

  });




  doc.html(body, {
    x:0,
    y:0,

    html2canvas: {
      scale: 0.5,
      width: width,
      height: height,
      windowWidth: width*2,
      windowHeight: height*2,

      allowTaint: true,
      useCORS: true,

      letterRendering: true,

      // Ignore SVGs and Imgs that don't have src, to avoid errors
      ignoreElements: el => {
        let ignore = false;
        if (el.id === "loader") {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'svg') {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && !el.src) {
          ignore = true;
        }
        else if (el.tagName.toLowerCase() === 'img' && el.src && el.src.match(/\.svg/gi)) {
          ignore = true;
        }
        return ignore;
      }
    }
  })
    .then(() => {
      doc.setFontSize(8);
      doc.setFont("Roboto-Regular", "normal");
      doc.setTextColor(titleFillColor);
      doc.text(`Prevalence: percentage of genomes that have the selected mutations or lineages,`, width - 10, 37, 'right');
      doc.text(`out of the total number of genomes on a given day`, width - 10, 45, 'right');

      // percentage Y of the number of sequences entered that day X
    })
    .then(() => {
      return drawFlagSvgs(doc);
    })
    .then(() => {
      return drawSvgFathomLogo(doc, height);
    })
    .then(() => {
      function drawSvg(_svg, i) {

        // console.log(_svg);

        let renderedRect = svgRects[i];

        return doc.svg(_svg, {
          x:renderedRect.left/2,
          y:renderedRect.top/2,
          width:renderedRect.width/2,
          height:renderedRect.height/2
        });

      }

      // Forces synchronous rendering of the svgs, as they won't draw in parallel
      function drawSvgs() {
        let p = Promise.resolve();
        svgs.forEach((svg, i) => {
          p = p.then(() => {
            return drawSvg(svg, i);
          });
        });

        return p;
      }

      return drawSvgs();

    // drawFlagSvgs(doc).then(() => {
    //   console.log('drawFlagSvgs complete');
    //     drawSvgs();
    // })
    })

    .then(() => {

      console.log('all promises complete');
      doc.save(getPdfFilename());
      cleanup();

    });


}


function drawFlagSvgs(doc) {

  // doc.setPage(page);

  let svgs = document.querySelectorAll(".province--shape img");
  // console.log('flag svgs', svgs);
  // svgs.forEach(svg => {
  //   console.log(svg, svg.src);
  // });

  function drawSvg(_svg, renderedRect) {

    //let renderedRect = _svg.getBoundingClientRect();

    // console.log('drawing svg');

    return doc.svg(_svg, {
      x:renderedRect.left/2,
      y:renderedRect.top/2,
      width:renderedRect.width/2,
      height:renderedRect.height/2
    });

  }

  let flagSvgsToDraw = [];
  let fetchPromises = [];

  svgs.forEach((svg, i) => {
    let cs = getComputedStyle(svg);
    let renderedRect = svg.getBoundingClientRect();
    if (cs.content && cs.content.match(/\.svg/gi)) {
      // console.log(cs.content, svg);
      let src = cs.content.replace(/url\("/gi, "").replace(/"\)/gi, "");
      console.log('loading svg', src);
      fetchPromises.push(
        fetch(src)
          .then(res => res.text())
          .then(svgData => {
            // console.log(svgData);

            // let dataTokens = svgData.split("<?xml version=\"1.0\" encoding=\"UTF-8\"?>");
            // let data = dataTokens[1];

            let data = svgData;

            let div = document.createElement("div");
            div.classList.toggle("hidden", true);
            div.classList.toggle("cleanup", true);
            document.body.appendChild(div);
            div.innerHTML = data;

            flagSvgsToDraw.push({
              renderedRect : renderedRect,
              svgEl : div.querySelector("svg")
            });
          })
      )
    }
    // p = p.then(() => drawSvg(svg, i));
  });

  let p = Promise.resolve();

  return Promise.all(fetchPromises)
    .then(() => {
      // console.log('svg data retrieved', flagSvgsToDraw);
      flagSvgsToDraw.forEach(svg => {
        p = p.then(() => drawSvg(svg.svgEl, svg.renderedRect));
      });
      return p;
    });

  //return p;

}

function updateFlagImgSrcs() {

  // console.log(body);

  // Pick up any images that don't have a 'src', and instead use css 'content', and swap their src out
  body.querySelectorAll("img").forEach(img => {

    // console.log(img);
    let cs = getComputedStyle(img);
    // console.log(cs, cs.content, img.src);
    if (cs.content && cs.content !== "normal" && !img.src) {
      let src = cs.content.replace(/url\("/gi, "").replace(/"\)/gi, "");

      // console.log(img, src);
      img.src = src;

      // console.log(img.src);

      // let bb = img.getBoundingClientRect();
      // img.setAttribute("height", bb.height);
      // img.setAttribute("width", bb.width);
    }
  });

  // console.log(body.querySelectorAll("img"));
  // body.querySelectorAll("img").forEach(img => {
  //   console.log(img, img.src);
  // });


}

function drawPdfTitle(label) {

  let yearsMatch = (startDate.get('year') === endDate.get('year'));

  let startDateLabel = `${ startDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ startDate.toFormat(CHART_DATE_FORMAT_MONTH) }`;

  if (!yearsMatch) {
    startDateLabel += ` ${ startDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;
  }

  let endDateLabel = `${ endDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ endDate.toFormat(CHART_DATE_FORMAT_MONTH) } ${ endDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

  let title = document.querySelector("#pdf-title");
  title.querySelector("h4").innerHTML = `${label + startDateLabel  } - ${  endDateLabel}`;


}

function drawPdfSourcesFooter() {

  let footer = document.querySelector("#pdf-footer");

  let now = DateTime.now();
  let downloadedDateLabel = `${ now.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ now.toFormat(CHART_DATE_FORMAT_MONTH) } ${ now.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

  footer.querySelector("#pdf-footer-downloaded h6").innerHTML = `Downloaded ${ downloadedDateLabel }`;


  let updateDateLabel = `${ updateDate.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ updateDate.toFormat(CHART_DATE_FORMAT_MONTH) } ${ updateDate.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }`;

  footer.querySelector("#pdf-footer-data-last-updated h6").innerHTML = `Data last updated ${ updateDateLabel }`;

}

function drawSvgFathomLogo(doc, height) {

  let logo = document.querySelector("#pdf-footer .fathom .glyph");
  let logoRect = logo.getBoundingClientRect();

  let logoSvgWrapper = document.createElement("div");
  logoSvgWrapper.innerHTML = logoSvgRaw;
  let logoSvg = logoSvgWrapper.querySelector("svg");
  logoSvg.setAttribute("viewBox", `0, 0, ${ logoRect.width } ${ logoRect.height }`);
  logoSvg.setAttribute("fill", "rgb(150, 150, 150)");

  return doc.svg(logoSvg, {
    x:logoRect.left/2,
    y:height - (logoRect.height / 2) - 1,
    width:logoRect.width,
    height:logoRect.height
  });
}

function getPdfFilename() {
  let title = ``;
  // data.locations.forEach(l => {
  //   title += getCountryId(getLocationDisplayName(l));
  //   title += `_`;
  // });


  let now = DateTime.now();

  let pdfFilename = `banyan_crosscut_${ title }${now.toFormat('yyLLdd')}.pdf`;
  console.log(pdfFilename);
  return pdfFilename;
}


function cleanup() {
  // if (svg) {
  //   svg.removeAttribute("viewBox");
  // }

  let cards = document.querySelectorAll(".card--chart");
  cards.forEach(card => {
    card.style.width = "";
    card.style.height = "";
  });


  body.style.width = "";
  body.style.height = "";
  body.classList.toggle("pdf-export", false);

  hideLoader();

  let cleanups = document.querySelectorAll(".cleanup");
  cleanups.forEach(c => {
    c.parentNode.removeChild(c);
  });

  resize(data);
}
